import Icon from '../components/Icon.vue'

Icon.register({
  bullseye: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 440c101.7 0 184-82.3 184-184 0-101.7-82.3-184-184-184-101.7 0-184 82.3-184 184 0 101.7 82.3 184 184 184zM248 128c70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128 57.3-128 128-128zM248 320c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bullseye.js
// module id = 1128
// module chunks = 0